var render = function render(){var _vm=this,_c=_vm._self._c;return _c('side-detail-card',{ref:"detail"})
}
var staticRenderFns = []

export { render, staticRenderFns }